export default class Logger {

    /**
     * Log a message
     * @param  {...any} args 
     */
    static async log(...args) {
        if (localStorage.debug) {
            console.log(...args)
        }
    }
}